import React, {Component} from "react";
import {Doughnut,Radar, Polar, Pie} from 'react-chartjs-2';

class RenderChart extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }


    renderChart(){
        let data = [15.35, 19.55, 65.1];
        let label = ['15.35 %', '19.55 %', '65.1 %'];
    
        return(
            <Doughnut
                data={{
                    // labels: label,
                    datasets: [{
                        data: data,
                        backgroundColor: [
                            '#F05454',
                            '#00C1D4',
                            '#EBA83A'
                        ] ,
                        width: 1
                    }]
                }}
                options = {{  
                    legend: {
                        labels: {                                
                            fontSize: 12,
                        }
                    }                       
                }}
            />
        )
    }


    render() { 
        return (
            this.renderChart()
        );
    }
}
 
export default RenderChart;